import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {ApplicationPackage} from '../../../enums/application-package.enum';
import {Service} from '../../../enums/service.enum';
import {Observable} from 'rxjs';
import {EncodePresetP} from 'src/app/model/encoder-manager/encode-preset.model';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {WatchFolderFile} from 'src/app/model/cms-vod-core/encoding-profiles-modals/watch-folder-file.model';
import { VideoFormats } from 'src/app/constants/general-constants';

@Injectable({
  providedIn: 'root',
})
export class EncodingProfilesService {
  readonly encodingProfilesUrl = environment.endPoint + ApplicationPackage.CMS_VOD + Service.ENCODER;

  constructor(private http: HttpClient) {}

  getAllEncodingProfiles(profileType?: string, autoTranscodeProfile?: boolean, name?: string, videoFormat?: string,
    encProfile ?: string, resolution ?: string, frameRate ?: string, audioCodec ?: string,
    keyFramePeriod ?: number, videoBitRate ?: number, width ?: number, height ?: number, sortParams?: string[]): Observable<EncodePresetP[]> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (profileType) {
      queryParams = queryParams.set('profileType', <any>profileType);
    }
    if (autoTranscodeProfile) {
      queryParams = queryParams.set('autoTranscodeProfile', <any>autoTranscodeProfile);
    }
    if (name != undefined && name != null) {
      queryParams = queryParams.set('name', <any>name);
    }
    if (videoFormat != undefined && videoFormat != null) {
      queryParams = queryParams.set('videoFormat', <any>videoFormat);
    }
    if (encProfile != undefined && encProfile != null) {
      queryParams = queryParams.set('encProfile', <any>encProfile);
    }
    if (keyFramePeriod != undefined && keyFramePeriod != null) {
      queryParams = queryParams.set('keyFramePeriod', <any>keyFramePeriod);
    }
    if (videoBitRate != undefined && videoBitRate != null) {
      queryParams = queryParams.set('videoBitRate', <any>videoBitRate);
    }
    if (resolution != undefined && resolution != null) {
      queryParams = queryParams.set('resolution', <any>resolution);
    }
    if (frameRate != undefined && frameRate != null) {
      queryParams = queryParams.set('frameRate', <any>frameRate);
    }
    if (audioCodec != undefined && audioCodec != null) {
      queryParams = queryParams.set('audioCodec', <any>audioCodec);
    }
    if (width != undefined && width != null) {
      queryParams = queryParams.set('width', <any>width);
    }
    if (height != undefined && height != null) {
      queryParams = queryParams.set('height', <any>height);
    }
    if (sortParams != undefined && sortParams != null) {
      queryParams = queryParams.set('sortParam', <any>sortParams);
    }

    return this.http.get<EncodePresetP[]>(this.encodingProfilesUrl + '/encodepresets');
  }

  getEncodingProfilesById(encodingProfileId: number): Observable<EncodePresetP> {
    return this.http.get<EncodePresetP>(this.encodingProfilesUrl + `/encodepreset/${encodingProfileId}`);
  }

  createEncodingProfile(encodingProfile: EncodePresetP): Observable<EncodePresetP> {
    return this.http.post<EncodePresetP>(this.encodingProfilesUrl + `/encodepreset/`, encodingProfile);
  }

  updateEncodingProfile(encodingProfile: EncodePresetP): Observable<EncodePresetP> {
    return this.http.put<EncodePresetP>(this.encodingProfilesUrl + `/encodepreset/`, encodingProfile);
  }

  deleteEncodingProfile(encodingProfileId: number): Observable<any> {
    return this.http.delete<any>(this.encodingProfilesUrl + `/encodepreset/${encodingProfileId}`);
  }

}
